import React from 'react';
import PropTypes from 'prop-types';

import { RegisterTrade } from 'C4';

import InputField from 'components/LoginForm/Input';
// TODO add password fields
// TO CHECK: Las Vegas (Firebase login)
const Register = props => (
  <div className="RegisterHolder">
    <h4 className="subtop">
      Please take a moment to complete all the information below, as this is
      what will populate your profile and contact information.
    </h4>
    {window.location.pathname !== '/exhibitor' && (
      <div className="step">
        Step 1: Complete your email address and choose a password.
      </div>
    )}
    <RegisterTrade
      passwordField
      back={props.back}
      submit={props.submit}
      change={props.change}
      loadingAnimRegister={props.loadingAnimRegister}
    />
  </div>
);

export default Register;

Register.propTypes = {
  passwordField: PropTypes.bool,
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
};

Register.defaultProps = {
  defaultVal: '',
  passwordField: false,
};
